module.exports = __webpack_public_path__ + "static/media/Skype.eaf7637a.png";